// Dependencies
import React from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';

// Components
import LayerHeading from './LayerHeading';
import Map from './Map';

// Shapes
import { coordinateShape } from '../propTypesShapes';


function MobileMap({ defaultCenter, isFeatureDescriptionShown }) {
  const hiddenMapStyle = isFeatureDescriptionShown ? 'd-none' : '';

  return (
    <div className='MobileMap d-flex flex-column h-100'>
      <LayerHeading
        showCurrentFeatureInfo
      />
      <Route exact path="/" render={(props) =>
        <Map className={hiddenMapStyle}
          isOnMobileView
          defaultCenter={defaultCenter}
          {...props}
        />
      }
      />
    </div>
  );
}

/* Not use withRouter and pass the location property due to
   https://github.com/ReactTraining/react-router/blob/v4.2.2/packages/
   react-router/docs/guides/blocked-updates.md */
MobileMap.propTypes = {
  defaultCenter: coordinateShape,
  isFeatureDescriptionShown: PropTypes.bool,
  location: PropTypes.object
};

export default connect(({ home }) => ({
  isFeatureDescriptionShown: home.isFeatureDescriptionShown
}), null)(MobileMap);
